import { SyntheticEvent, useCallback, useState } from "react";

export interface UseSandboxedHTMLPreviewResult {
  /** Measured content height in pixels (0 until the iframe has loaded at least once). */
  height: number;
  /** `onLoad` handler for the iframe — measures and stores the content height. */
  handleLoad: (event: SyntheticEvent<HTMLIFrameElement>) => void;
}

/**
 * Logic for {@link SandboxedHTMLPreview}: measures the iframe content height to auto-resize the
 * frame. Because changing `srcDoc` reloads the iframe (firing its `load` event), resizing is
 * handled in the `onLoad` event handler — no `useEffect` is needed.
 */
export const useSandboxedHTMLPreview = (): UseSandboxedHTMLPreviewResult => {
  const [height, setHeight] = useState(0);

  const handleLoad = useCallback((event: SyntheticEvent<HTMLIFrameElement>) => {
    const body = event.currentTarget.contentDocument?.body;
    if (body) setHeight(body.scrollHeight);
  }, []);

  return { height, handleLoad };
};
